import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';
import { IGNORE_META_MESSAGE } from '@sb/shared/util';
import { Observable } from 'rxjs';

import { DeactivatedEmployee } from '../models/new-hires.model';

@Injectable({ providedIn: 'root' })
export class RehireService {
  private api: ApiGateway = inject(ApiGateway);

  private uri = 'hiring';

  getInactiveEmployees(): Observable<DeactivatedEmployee[]> {
    return this.api.get<DeactivatedEmployee[]>(`${this.uri}/deactivated-employees`, {
      context: new HttpContext().set(IGNORE_META_MESSAGE, true),
    });
  }
}
